export const INIT_APP = 'INIT_APP';
export const INIT_PROTOCOL = 'INIT_PROTOCOL';

export const initProtocol = (protocol) => ({
  type: INIT_PROTOCOL,
  protocol
});

export const initApp = ({title, debugFunc, fullFunc, closeFunc}) => ({
  type: INIT_APP,
  title,
  debugFunc,
  fullFunc,
  closeFunc
});



// WEBPACK FOOTER //
// ./src/actions/chat-root/index.js